// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__wDqaw","calendarButtons":"ClockData_calendarButtons__XXHio"};